import { buildRouteTree } from "utils/routeUtils";

export const routes = buildRouteTree({
	launches: null,
	market: null,
	discover: null,
	marketplace: {
		realEstate: null
	},
	profile: {
		dashboard: null
	},
	wallet: {
		dashboard: null
	},
	tokenIssuance: {
		congratulations: null
	},
	logout: null
});
